import { render } from "./PostsTitle.vue?vue&type=template&id=3855b352"
import script from "./PostsTitle.vue?vue&type=script&lang=js"
export * from "./PostsTitle.vue?vue&type=script&lang=js"

import "./PostsTitle.vue?vue&type=style&index=0&id=3855b352&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__